import * as http from "../index";
const buildLookupRequest = (lookupRequest) => {
    const content = {
        branchId: lookupRequest.branchId,
        duration: lookupRequest.duration,
        downPayment: lookupRequest.downPayment,
        residual: lookupRequest.residual,
        financialOptionId: lookupRequest.financialOptionId,
    };
    return http
        .builder()
        .method("post")
        .accept("application/json")
        .content(content)
        .build();
};
const validateResponse = (response) => {
    if (!response || !response.successful || !response.response) {
        throw new Error("The request did not succeed");
    }
    return response.response;
};
export const lookup = (lookupRequest, config) => http
    .json(`${config.getApiAddress()}/payment/${lookupRequest.id}`, buildLookupRequest(lookupRequest))
    .then(validateResponse);
